import React, { useState, useEffect } from "react";
import { Input, Tooltip, FormFeedback } from "reactstrap";

const UrlInput = ({
    id,
    name,
    value = "",
    onChange = () => {},
    onBlur = () => {},
    label="URL",
    placeholder = "Enter URL",
    layout = "below",
    required = false,
    requiredErrorMessage = "This field is required.",
    validationErrorMessage = "Please enter a valid URL.",
    helpText = "",
    showHelp = false,
    validateTrigger, // Trigger for validation on form submission
}) => {
    const [inputValue, setInputValue] = useState(value);
    const [errors, setErrors] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        setInputValue(value); // Set inputValue when value prop changes
    }, [value]);

    const validateInput = (val) => {
        const newErrors = {};

        // Regex for URL validation
        const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;

        if (required && !val) {
            newErrors.required = requiredErrorMessage;
        } else if (val && !urlRegex.test(val)) {
            newErrors.validation = validationErrorMessage;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);

        // Call Formik's onChange to update Formik state
        onChange({
            target: {
                name: name,
                value: newValue,
            },
        });
    };

    const handleInputBlur = (e) => {
        validateInput(e.target.value);
        onBlur(e);
    };

    useEffect(() => {
        if (validateTrigger) {
            validateInput(inputValue);
        }
    }, [validateTrigger, inputValue]);

    return (
        <div className={layout === "inline" ? "d-flex align-items-center mb-2" : "mb-2"}>
            <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
                {label}
                {required && <span className="text-danger ml-1">*</span>}
                {showHelp && (
                    <span id="helpTooltip" className="px-2">
                        <i className="ri-question-line" style={{ cursor: "pointer", fontSize: "16px" }}></i>
                    </span>
                )}
            </label>
            {showHelp && (
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target="helpTooltip"
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                    {helpText}
                </Tooltip>
            )}
            <div className="w-100">
                <Input
                    type="text"
                    name={name}
                    id={id}
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    invalid={!!errors.required || !!errors.validation}
                />
                {errors.required && <FormFeedback type="invalid">{errors.required}</FormFeedback>}
                {errors.validation && <FormFeedback type="invalid">{errors.validation}</FormFeedback>}
            </div>
        </div>
    );
};

export default UrlInput;
